<template>
	<front-admin-hub module-key="member" />
</template>
<script>
import FrontAdminHub from '@/components/FrontAdminHub/index.vue';
export default {
	name: 'MemberManage',
	components: { FrontAdminHub },
};
</script>
